import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useCan } from '../auth/Can';
import AgentDesk from '../components/support/AgentDesk';
import QualityPanel from '../components/support/QualityPanel';
import AutomationsList from '../components/support/AutomationsList';

/** R2b-4 (owner, 21 Oct): Customer Support → Team & quality — who is on duty (and your own desk), agent stats + QA sample,
 *  and the automation rules. Moved here from the top of the tickets list. */
const SupportTeam: React.FC = () => {
    const { canAny } = useCan();
    const navigate = useNavigate();
    return (
        <Box sx={{ p: 2, maxWidth: 1400, mx: 'auto' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1, mb: 1 }}>
                <Typography variant="h5" sx={{ fontWeight: 700 }}>Team &amp; quality</Typography>
                {canAny(['support:lead', 'config:write'] as any) && (
                    <Button size="small" variant="outlined" onClick={() => navigate('/support-settings')} data-testid="open-support-settings">Support settings</Button>
                )}
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Your desk status and who is on duty, each agent's numbers and QA reviews, and the rules that run on their own.
            </Typography>
            <AgentDesk />
            <QualityPanel />
            <AutomationsList />
        </Box>
    );
};

export default SupportTeam;
